import React, { Component } from 'react';
import { connect } from 'react-redux';

import Routes from '../components/Routes';

const mapStateToProps = (state) => ({
  auth: state.auth.details,
});

function withAuth(AuthComponent) {
  class Authenticated extends Component {
    componentDidMount() {
      const { auth: { data = true} } = this.props;
      if (!data && window.location.pathname !== Routes.TERM_OF_USE.path) {
        window.location.href = Routes.TERM_OF_USE.path;
      }
    }

    render() {
      return <AuthComponent {...this.props} />;
    }
  }

  return connect(mapStateToProps)(Authenticated);
}

export default withAuth;
